import {
  TOKEN_USED,
  RESET_TOKEN,
} from "../constants/ActionTypes";

// The purpose of this reducer is to record the state of the token returned by
// the ReCAPTCHA verification api call, as it can only be used once. Once a
// token has been sent to the OneLogin backend, it needs to be invalidated
// by setting the `tokenUsed` state to `true`. The ProtectedSubmit component,
// which wraps the ReCAPTCHA component, can then reset itself and then reset
// the `tokenUsed` state. This means that all requests will require redoing the
// ReCAPTCHA challenge (which is what you want, anyways).
const recaptcha = (state = { tokenUsed: false }, action) => {
  switch(action.type) {
    case RESET_TOKEN:
      return { tokenUsed: false };
    case TOKEN_USED:
      return { tokenUsed: true };
    default:
      return state;
  }
};

export default recaptcha;
